<template>
  <div>
    <div class="foot">
      <div class="foot_container">
        <div class="me_line">
          <div class="me_b">
            <div class="me_b_l">
              <img src="@/assets/svg/phone1.svg" alt="" />
            </div>
            <div class="me_b_r">
              <div class="me_b_r_1">全天候品质服务</div>
              <div class="me_b_r_2">7×24小时专业工程师服务</div>
            </div>
          </div>
          <div class="me_b">
            <div class="me_b_l">
              <img src="@/assets/svg/kefu1.svg" alt="" />
            </div>
            <div class="me_b_r">
              <div class="me_b_r_1">极速服务应答</div>
              <div class="me_b_r_2">秒级应答为业务报价护航</div>
            </div>
          </div>
          <div class="me_b">
            <div class="me_b_l">
              <img src="@/assets/svg/jiazhi1.svg" alt="" />
            </div>
            <div class="me_b_r">
              <div class="me_b_r_1">客户价值为先</div>
              <div class="me_b_r_2">从服务价值到创造客户价值</div>
            </div>
          </div>
          <div class="me_b">
            <div class="me_b_l">
              <img src="@/assets/svg/fuwu1.svg" alt="" />
            </div>
            <div class="me_b_r">
              <div class="me_b_r_1">全天候品质服务</div>
              <div class="me_b_r_2">让追光标准成为世界的标准</div>
            </div>
          </div>
        </div>
        <div class="heng_line"></div>
        <div class="lianxi">
          <div class="lianxi1">联系我们</div>
          <div class="lianxi2">咨询热线：<span>400-075-8858</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>0516-85030809</span></div>
          <div class="lianxi3">电子邮箱：163go126@163.com</div>
          <div class="lianxi3">地址：江苏省徐州市高新区银山路16号（联东U谷）9号楼</div>

          <div class="code_container code1">
            <div class="codeimg">
              <img src="@/assets/gzhcode.png" alt="" />
            </div>
            <div class="code_text">微信公众号</div>
          </div>
          <div class="code_container code2">
            <div class="codeimg">
              <img src="@/assets/jlcode.png" alt="" />
            </div>
            <div class="code_text">合作微信</div>
          </div>
          <div class="code_container code3">
            <div class="codeimg">
              <img src="@/assets/tbcode.png" alt="" />
            </div>
            <div class="code_text">淘宝店铺</div>
          </div>
        </div>
        <div style="background: rgba(0, 0, 0, 0.2)" class="heng_line"></div>
        <div class="beian">Copyright © 2019-2024 江苏追光智能科技有限公司 版权所有 Powered by EyouCms 备案号：苏ICP备20027758号-2</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'foot',
  data() {
    return {}
  },

  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.foot {
  height: 538px;
  background-color: rgba(24, 24, 24, 1);
  padding-top: 0.1px;
  .foot_container {
    width: 1608px;
    margin: 56px auto 0 auto;
    .me_line {
      margin-top: 56px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .me_b {
        width: 324px;
        height: 64px;
        display: flex;
        align-items: center;
        overflow: hidden;
        .me_b_l {
          width: 64px;
          height: 64px;
          margin-right: 19.5px;
          img {
            width: 64px;
            height: 64px;
          }
        }
        .me_b_r {
          height: 64px;
          .me_b_r_1 {
            font-size: 24px;
            line-height: 32px;
            color: rgba(255, 255, 255, 0.9);
          }
          .me_b_r_2 {
            font-size: 20px;
            line-height: 28px;
            color: rgba(255, 255, 255, 0.55);
          }
        }
      }
    }
    .heng_line {
      margin-top: 48px;
      height: 1px;
      background: rgba(231, 231, 231, 1);
    }
  }
  .lianxi {
    margin-top: 48px;
    position: relative;
    color: rgba(255, 255, 255, 0.9);
    .lianxi1 {
      font-size: 24px;
      line-height: 32px;
    }
    .lianxi2 {
      margin-top: 24px;
      font-size: 20px;
      span {
        font-size: 46px;
        line-height: 44px;
        color: rgba(255, 255, 255, 1);
      }
    }
    .lianxi3 {
      margin-top: 12px;
      font-size: 20px;
      line-height: 28px;
    }
    .code_container {
      position: absolute;
      top: 0px;
      width: 144px;
      height: 180px;
      overflow: hidden;
      .codeimg {
        width: 144px;
        height: 144px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.4s ease;
        }
      }
      .codeimg:hover {
        img {
          transform: scale(1.1);
        }
      }
      .code_text {
        margin-top: 12px;
        font-size: 16px;
        line-height: 24px;
        color: rgba(255, 255, 255, 0.9);
        text-align: center;
      }
    }
    .code1 {
      right: 0;
    }
    .code2 {
      right: 172px;
    }
    .code3 {
      right: 344px;
    }
  }
  .beian {
    margin-top: 24px;
    font-size: 16px;
    text-align: center;
    color: rgba(255, 255, 255, 0.43);
  }
}
</style>
